import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  BackArrow,
  Input,
  CheckBox,
  Button,
  TopProgress
} from '../../../../components'
import {
  Container,
  TitleBig,
  FormWrapper,
  CreateContainer,
} from './styles'
import * as yup from 'yup';
import { useFormik } from 'formik';
import { clientService } from '../../../../api'
import { useUi } from '../../../../context/ui.context'
import { usePageTitle } from '../../../../context/navigationContext'

const CreateClientGroup:FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [t] = useTranslation()
  const {viewAlert} = useUi()
  usePageTitle(t("PAGE_TITLE_CLIENT_GROUP_CREATE"))
  const {groupId} = useParams()
  const [clientGroup, setClientGroup] = useState<any>()
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false)
  const [portSecurity, setPortSecurity] = useState<boolean>(true)
  const [initialValues, setInitialValues] = useState<any>({
    name:'',
    description:'',
  })
  const getCreateOptions = async () => {
    try{
      if(groupId){
        const portRes = await clientService.getClientGroup(groupId)
        setClientGroup(portRes?.data)
        setInitialValues({
          name:portRes?.data?.name,
          description:portRes?.data?.description,
          is_default:portRes?.data?.is_default,
        })
        setPortSecurity(portRes?.data?.is_default)
      }

      await setPageLoading(false)
    } catch (e) {

    }

  }

  useEffect(() => {
    getCreateOptions()
  },[])

  const onSubmit = (values:any) => {
    setLoading(true)
    const data = {
      ...values,
      is_default:portSecurity,
    }

    if(!location.pathname.includes('create') && clientGroup){
      clientService.editClientGroup({...clientGroup, ...data})
      .then((res) => {
        setLoadingComplete(true)
        setTimeout(() => {
          navigate("/clients-users/client-groups")
          // resetForm()
          setLoadingComplete(false)
          setLoading(false)
        },1000)
      })
      .catch((err:any) => {
        setLoading(false)
        viewAlert({
          severity:'error',
          message: err?.response?.data?.detail || `${t("ERROR_OCCURRED")}`
        })
      })
    } else {
      clientService.createClientGroup(data)
      .then((res) => {
        setLoadingComplete(true)
        setTimeout(() => {
          navigate("/clients-users/client-groups")
          // resetForm()
          setLoadingComplete(false)
          setLoading(false)
        },1000)
      })
      .catch((err:any) => {
        setLoading(false)
        viewAlert({
          severity:'error',
          message: err?.response?.data?.detail || `${t("ERROR_OCCURRED")}`
        })
      })
    }
  }

  const regName = /^[a-zA-Z0-9\\!\"#$%&'()*+,\-./:;<=>?@\[\\\]\^_`{\|}~ ]+$/

  const {
    values,
    errors,
    touched,
    resetForm,
    handleSubmit,
    handleChange,
    setFieldValue,
    handleBlur,
  } = useFormik({
    // enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(`${t("FIELD_REQUIRED")}`)
      .matches(regName,`${t("ONLY_ENGLISH_LETTERS")}`)
      .max(60, `${t("STRING_VALIDATE_MAX")} 60 ${t("CHARACTERS")}`),
      description: yup.string().max(255, `${t("STRING_VALIDATE_MAX")} 255 ${t("CHARACTERS")}`),
    }),
    initialValues: {
      ...initialValues,
    },
    onSubmit,
  });
  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };

  const isEdit = !location.pathname.includes('create') && clientGroup
  // if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <CreateContainer>
      <Container>
        <BackArrow
          fallbackPath="/clients-users/client-groups"
        />
        <TitleBig style={{margin:'0px'}}>{isEdit ? t("EDIT_CLIENT_GROUP") + ' ' + (clientGroup?.name || clientGroup?.id) : t("CREATE_A_NEW_CLIENT_GROUP")}</TitleBig>
        <FormWrapper>
          <Input
            fieldName='name'
            title={t("NAME")}
            required
            placeholder=''
            customStyles={{width:'100%'}}
            {...formikProps}
          />
          <Input
            fieldName='description'
            isTextArea
            title={t("DESCRIPTION")}
            placeholder=''
            customStyles={{width:'100%'}}
            {...formikProps}
          />
        </FormWrapper>
        <CheckBox
          value={portSecurity}
          onChange={() => setPortSecurity(!portSecurity)}
          title={t("IS_DEFAULT")}
        />
        <div style={{display:'flex', marginTop:'20px'}}>
          <Button
            variant="primary"
            size="display"
            loading={loading}
            loadingComplete={loadingComplete}
            customStyles={{marginRight:"10px"}}
            onClick={handleSubmit}
            title={isEdit ? t("EDIT") : t("CREATE")}
          />
          <Button
            variant="stroke"
            size="display"
            onClick={() => navigate("/clients-users/client-groups")}
            title={t("CANCEL")}
          />
        </div>
      </Container>
    </CreateContainer>
  )
}

export default CreateClientGroup

